import { getImagesByQuery } from './js/pixabay-api.js';
import { 
    createGallery, 
    clearGallery, 
    showLoader, 
    hideLoader, 
    showLoadMoreButton, 
    hideLoadMoreButton 
} from './js/render-functions.js';
import iziToast from "izitoast";
import "izitoast/dist/css/iziToast.min.css";

// Елементи DOM
const form = document.querySelector('.form');
const searchInput = form.elements['search-text'];
const loadMoreBtn = document.querySelector('#loadMoreBtn');
const galleryElement = document.querySelector('.gallery');

// Глобальний стан пагінації та пошуку
let currentPage = 1;
let currentQuery = '';
let totalHits = 0;
const perPage = 15; // Кількість зображень на сторінці

/**
 * Відображає повідомлення про помилку за допомогою iziToast.
 * @param {string} message - Текст повідомлення.
 */
function showErrorMessage(message) {
    iziToast.error({
        title: 'Error',
        message: message,
        position: 'topRight',
        backgroundColor: '#ef4040',
        messageColor: '#fff',
        titleColor: '#fff',
    });
}

/**
 * Виконує плавне прокручування сторінки на дві висоти картки галереї.
 */
function smoothScroll() {
    // Перевіряємо, чи є елементи в галереї
    const firstGalleryItem = galleryElement.firstElementChild;
    if (firstGalleryItem) {
        // Отримуємо висоту першої картки галереї
        const cardHeight = firstGalleryItem.getBoundingClientRect().height;
        
        // Прокрутка на дві висоти картки
        window.scrollBy({
            top: cardHeight * 2,
            behavior: 'smooth',
        });
    }
}


/**
 * Перевіряє, чи досягнуто кінця колекції, та приховує/показує кнопку.
 */
function checkEndOfTheCollection() {
    const loadedImagesCount = currentPage * perPage;
    
    if (loadedImagesCount >= totalHits) {
        hideLoadMoreButton();
        if (totalHits > 0) { // Показуємо повідомлення, лише якщо були знайдені зображення
             iziToast.info({
                message: "We're sorry, but you've reached the end of search results.",
                position: 'bottomCenter',
                backgroundColor: '#38b0ff',
                messageColor: '#fff',
            });
        }
    } else {
        showLoadMoreButton();
    }
}

/**
 * Основна функція для виконання запиту та оновлення інтерфейсу.
 * @param {boolean} isNewSearch - Чи це новий пошук (true) чи завантаження наступної сторінки (false).
 */
async function fetchImages(isNewSearch = true) {
    // 1. Приховати кнопку Load more перед запитом
    hideLoadMoreButton(); 
    // 2. Відображення лоадера
    showLoader(); 

    try {
        const data = await getImagesByQuery(currentQuery, currentPage);
        const images = data.hits;
        totalHits = data.totalHits;

        if (isNewSearch) {
            // 3.1. Логіка для НОВОГО ПОШУКУ
            if (images.length === 0) {
                showErrorMessage("Sorry, there are no images matching your search query. Please try again!");
                clearGallery(); 
                return;
            }
            // Очищення та відмальовування першої сторінки
            clearGallery(); 
            createGallery(images);
            // Плавна прокрутка не потрібна при першому завантаженні
        } else {
            // 3.2. Логіка для LOAD MORE
            createGallery(images);
            // Плавна прокрутка після додавання нових елементів
            smoothScroll(); 
        }

        // 4. Перевірка кінця колекції та відображення кнопки
        checkEndOfTheCollection();

    } catch (error) {
        console.error(error);
        showErrorMessage("An error occurred while fetching images. Please try again later.");
    } finally {
        // 5. Приховування лоадера
        hideLoader();
    }
}

/**
 * Обробник події сабміту форми (новий пошук).
 */
async function handleSearch(event) {
    event.preventDefault(); 

    const query = searchInput.value.trim();

    if (query === "") {
        showErrorMessage("Please enter a search query.");
        return;
    }

    // Скидання стану для нового пошуку
    currentPage = 1;
    currentQuery = query;
    totalHits = 0;

    // Виклик основного fetch-функціоналу
    await fetchImages(true); 
    
    // Очищення поля вводу
    form.reset(); 
}

/**
 * Обробник кліку на кнопку "Load more" (наступна сторінка).
 */
async function handleLoadMore() {
    // Збільшуємо номер сторінки
    currentPage += 1; 

    // Виклик основного fetch-функціоналу
    await fetchImages(false); 
}

// Додавання слухачів подій
form.addEventListener('submit', handleSearch);
loadMoreBtn.addEventListener('click', handleLoadMore);